<template>
    <div>
        <!-- TOOLBAR -->
        <div class="col-12 lg:col-12 px-0">
            <Toolbar class="mb-2">
                <template #start>
                <div class="grid">
                    <div class="col-5">
                        <Dropdown class="w-full"
                            v-model="filtros.unidad"
                            :options="lstUnidades"
                            optionLabel="Descripcion_unidad_informacion"
                            placeholder="Selecciona una unidad"
                            :showClear="true"
                            :filter="true"
                            :filterFields="['Descripcion_unidad_informacion','Unidad_informacion']">
                        <template #value="slotProps">
                            <div v-if="slotProps.value"> 
                                <div v-if="slotProps.value.Unidad_informacion>0">                            
                                    <span style="font-weight:bold">{{slotProps.value.Unidad_informacion}} -</span>
                                    {{slotProps.value.Descripcion_unidad_informacion}}
                                </div>
                                <div v-else>
                                    {{slotProps.value.Descripcion_unidad_informacion}}
                                </div>
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div v-if="slotProps.option"> 
                                <div v-if="slotProps.option.Unidad_informacion>0">                            
                                    <span style="font-weight:bold">{{slotProps.option.Unidad_informacion}} -</span>
                                    {{slotProps.option.Descripcion_unidad_informacion}}
                                </div>
                                <div v-else>
                                    {{slotProps.option.Descripcion_unidad_informacion}}
                                </div>
                            </div>
                        </template>      
                        </Dropdown>
                    </div>
                    <div class="col-2">
                        <InputText v-model="filtros.folio" class="w-full" placeholder="Folio"/>
                    </div>
                    <div class="col-5">
                        <span class="p-float-label">
                            <Calendar
                                v-model="filtros.fechas" 
                                selectionMode="range" 
                                :showIcon="true"
                                dateFormat="dd/mm/yy"
                                class="w-full"
                                :manualInput="false"
                                placeholder="Seleccione rango de fechas"/>
                        </span>
                    </div>
                </div>
                </template>
                <template #end>
                    <Button id="id-btn-filtro" label="Buscar" icon="pi pi-search" class="p-button-info mr-2" @click="btnFiltro"/>
                    <Button id="id-btn-limpiar" label="Limpiar" icon="pi pi-filter-slash" class="p-button-danger mr-2" @click="btnLimpiarFiltro"/>
                    <Button label="Nuevo" icon="pi pi-plus" class="p-button-success mr-2" @click="agregarSalida"/>                
                </template>
            </Toolbar>
        </div>

        <!-- DATAGRID -->
        <DataTable
            v-if="lstCBMs2 != null"
            :value="lstCBMs2"
            dataKey="Id_cbm2"
            ref="dt"
            v-model:filters="filters" 
            :globalFilterFields="['Id_cbm2',
                                'EL_C',
                                'Trabajador_de',
                                'Adscrito',
                                'Matricula',
                                'Bienes_de',
                                'Para_su',
                                'Firma_entrega',
                                'Firma_recibe',
                                'Sello',
                                'Folio_remedy',
                                'UI',
                                'CC',
                                'UBI']"           
            :loading="loading"
            :paginator="true"
            :rows="10"
            scrollable
            responsiveLayout="scroll"
            scrollDirection="both"
            scrollHeight="550px"
            filterDisplay="row"
        >
            <template #header>                
                <h5>Salidas</h5>
                <div class="flex justify-content-between">
                    <div class="col-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText type="text" v-model="filters['global'].value"  placeholder="Buscar..."/>
                        </span>
                    </div>
                        <span>
                            <h5>
                                CBMs encontradas: {{ lstCBMs2 ? lstCBMs2.length : 0 }}
                            </h5>
                        </span>
                </div>
            </template>
            <template #empty> No se encontrarón registros. </template>
            <template #loading> Cargando datos. Espere por favor. </template>       
            <Column style="width: 10%">
                <template #body="slotProps">
                    <Button
                        icon="pi pi-eye"
                        class="p-button-rounded p-button-success mr-1"
                        @click="verDetallesCBM2(slotProps.data)"
                        v-tooltip="''"
                    />    
                </template>
            </Column>                 
            <Column style="width: 10%" field="Id_cbm2" header="Folio" >
                <template #body="{ data }">
                    <span class="font-bold"> No. {{ data.Id_cbm2 }} </span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" @input="filterCallback()" placeholder="Folio" />
                </template>
            </Column>
            <Column style="width: 20rem" field="Adscrito" header="Adscrito" sortable ></Column>
            <Column style="width: 20rem" field="EL_C" header="Trabajador" sortable ></Column>            
            <Column style="width: 20rem" field="Firma_entrega" header="Entrega" sortable ></Column>
            <Column style="width: 20rem" field="Firma_recibe" header="Recibe" sortable ></Column>
            <Column style="width: 8rem" field="Fecha_registro" header="Fecha" sortable >            
                <template #body="slotProps">
                    {{getFechaWCF(slotProps.data.Fecha_registro,false)}}
                </template>
            </Column>
            <Column style="width: 10rem" field="Folio_remedy" header="F. Remedy" sortable ></Column>
            <Column style="width: 6rem" field="UI" header="UI" sortable ></Column>
            <Column style="width: 6rem" field="CC" header="CC" sortable ></Column>
            <Column header="Id_estatus">
                <template #body="slotProps">
                    <Tag :value="util.getEstatusSalidasEquipos(slotProps.data.Id_estatus)?.label" :severity="util.getEstatusSalidasEquipos(slotProps.data.Id_estatus)?.severity" />
                </template>
            </Column>
        </DataTable>

        <!-- DIALOG CAPTURA NUEVA SALIDA -->
        <Dialog 
        :style="{ width: '750px' }"
        :visible="showNewSalida"
        :modal="true"   
        :closable="false">
            <template #header>
                <h3>Nueva salida</h3>
            </template>   
            <div class="grid">
                <div class="col-12">
                    <label>Unidad</label>
                    <Dropdown class="w-full"
                            v-model="objSalida.Unidad_seleccionada"
                            :options="lstUnidadesDialog"
                            optionLabel="Descripcion_unidad_informacion"
                            placeholder="Selecciona una unidad"
                            :showClear="true"
                            :filter="true"
                            :filterFields="['Descripcion_unidad_informacion','Unidad_informacion']"
                            @change="cargaRCABSDeUnidad">
                        <template #value="slotProps">
                            <div v-if="slotProps.value">                                                        
                                <div v-if="slotProps.value.Unidad_informacion>0">                            
                                    <span style="font-weight:bold">{{slotProps.value.Unidad_informacion}} -</span>
                                    {{slotProps.value.Descripcion_unidad_informacion}}
                                </div>
                                <div v-else>
                                    {{slotProps.value.Descripcion_unidad_informacion}}
                                </div>
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div v-if="slotProps.option"> 
                                <div v-if="slotProps.option.Unidad_informacion>0">                            
                                    <span style="font-weight:bold">{{slotProps.option.Unidad_informacion}} -</span>
                                    {{slotProps.option.Descripcion_unidad_informacion}}
                                </div>
                                <div v-else>
                                    {{slotProps.option.Descripcion_unidad_informacion}}
                                </div>
                            </div>
                        </template>      
                    </Dropdown>
                </div>
                <div class="col-12">
                    <label>Centro de Costo y RCAB de la unidad</label>
                    <Dropdown class="w-full"
                            v-model="objSalida.RCAB_seleccionado"
                            :options="lstRCABSUnidad"
                            placeholder="Selecciona un RCAB"
                            :showClear="true"
                            :filter="true"
                            :filterFields="['CC','Descripcion_centro_costo','Matricula_rcab','Nombre_rcab']"
                            >
                        <template #value="slotProps">
                            <div v-if="slotProps.value">                                                        
                                <span style="font-weight:bold">{{slotProps.value.Ubicacion}} - {{slotProps.value.CC}} - </span>
                                {{slotProps.value.Nombre_rcab}}                                
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div v-if="slotProps.option">                                 
                                <span style="font-weight:bold">{{slotProps.option.Ubicacion}} - {{slotProps.option.CC}} - {{ slotProps.option.Descripcion_centro_costo }}</span>
                                {{slotProps.option.Nombre_rcab}} 
                            </div>
                        </template>      
                    </Dropdown>
                </div>
                <Divider></Divider>
                <div class="col-12 flex justify-content-end">
                    <div>
                        <Button label="Agregar producto" icon="pi pi-plus" @click="showGridProductos" />                                 
                    </div>
                </div>
                <div class="col-12">
                    <DataTable                        
                        :value="objSalida.Productos"                        
                        ref="dt"                                                
                        responsiveLayout="scroll"
                        scrollable 
                        scrollDirection="both"
                        scrollHeight="350px"
                        v-model:editingRows="editingProducts"
                        editMode="row"      
                        dataKey="uuid"                  
                        tableClass="editable-cells-table"
                        @row-edit-save="onRowEditSave"
                    >                        
                        <template #empty> No se encontrarón registros. </template>
                        <template #loading> Cargando datos. Espere por favor. </template>                               
                        <Column style="width: 15%" field="Identificacion_cantidad" header="Identificación">
                            <template #editor="{ data, field }">
                                <InputText v-model="data[field]" />
                            </template>
                        </Column>
                        <Column style="width: 15%" field="Naturaleza_bien" header="Naturaleza">
                            <template #editor="{ data, field }">
                                <Dropdown v-model="data[field]" :options="naturalezas" placeholder="Naturaleza del bien">                                    
                                </Dropdown>
                            </template>
                            <template #body="slotProps">
                                <Tag :value="slotProps.data.Naturaleza_bien" severity="success" />
                            </template>
                        </Column>
                        <Column style="width: 50%" field="Descripcion" header="Producto"></Column>    
                        <Column :rowEditor="true" style="width: 10%;" bodyStyle="text-align:center"></Column>
                        <Column style="width: 10%">
                            <template #body="slotProps">
                                <Button
                                    icon="pi pi-times"
                                    class="p-button-outlined p-button-rounded p-button-danger"                                    
                                    @click="eliminarProductos(slotProps.data.uuid)"
                                />              
                            </template>
                        </Column>                                                          
                    </DataTable>
                </div>
                
                <div class="col-4">
                    <label>Folio remedy</label>
                    <InputText v-model="objSalida.Folio_remedy" />                    
                </div>
                <div class="col-4 flex align-items-center pt-4">
                    <Checkbox v-model="objSalida.Sujeto_a_devolucion" :binary="true" id="sujeto_devolucion" class="mr-2"/>
                    <label for="sujeto_devolucion">¿Sujeto a devolución?</label>
                </div>
                <div v-show="objSalida.Sujeto_a_devolucion" class="col-4">                    
                    <label>Fecha devolución</label>
                    <Calendar class="w-full" v-model="objSalida.Fecha_devolucion" /> 
                </div>

                <div class="col-12">
                    <div class="grid flex align-items-center h-4rem">
                        <div class="col-6">
                            <label for="PENAEC" class="pr-2">¿Es PNAEC?</label>
                            <Checkbox
                                id="PENAEC"
                                name="PENAEC"
                                :binary="true"
                                v-model="objSalida.PENAEC"
                            />
                        </div>
                        <div class="p-field col-6">
                            <label for="Numero_penaec"></label>
                            <InputText v-if="objSalida.PENAEC"
                                type="text"
                                id="Numero_penaec"
                                name="Numero_penaec"
                                v-model="objSalida.Numero_penaec"
                                placeholder="Numero de PNAEC"
                                maxlength="10"
                                :class="{ 'p-invalid': submitted && objSalida.PENAEC && !objSalida.Numero_penaec }"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="grid flex align-items-center h-4rem">
                        <div class="col-6">
                            <label for="Programa_mantenimiento" class="pr-2">¿Es programa de mantenimiento?</label>
                            <Checkbox
                                id="Programa_mantenimiento"
                                name="Programa_mantenimiento"
                                :binary="true"
                                v-model="objSalida.Programa_mantenimiento"
                            />
                        </div>
                        <div class="p-field col-6">
                            <label for="Programa_mantenimiento_anio"></label>
                            <Calendar v-if="objSalida.Programa_mantenimiento"
                                id="Programa_mantenimiento_anio"
                                name="Programa_mantenimiento_anio"
                                v-model="objSalida.Programa_mantenimiento_anio"
                                placeholder="Año del programa"
                                view="year" dateFormat="yy" 
                                :class="{ 'p-invalid': submitted && objSalida.Programa_mantenimiento && !objSalida.Programa_mantenimiento_anio }"
                                class="w-full"
                                :pt="{
                                    input : {
                                        maxlength: 10
                                    }
                                }"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <label>Para su uso</label>
                    <Textarea class="w-full" v-model="objSalida.Para_su" rows="1" />
                </div>

                <div class="col-6">
                    <label>Estado físico</label>
                    <Textarea class="w-full" v-model="objSalida.Estado_fisico" rows="1" />
                </div>

                <div class="col-12">
                    <InlineMessage v-show="mensajes" >{{ mensajes }}</InlineMessage >
                </div>
            </div>
            <template #footer>                
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cerrarDialogo()"/>                
                <Button label="Aceptar" icon="pi pi-check" class="p-button-text" @click="guardarSalida()"/>                
            </template>
        </Dialog>

         <!-- DIALOG PRODUCTOS -->
         <Dialog v-model:visible="showDialogProductos" header="Productos" style="width: 60vw;" maximizable modal >            
            <DataTable
            :value="lstProductos"
            dataKey="Id_producto"
            ref="dt"
            v-model:filters="filters"
            :globalFilterFields="['Producto', 'Marca', 'Modelo']"
            :loading="loadingProductos"
            v-model:selection="selectedProducts"
            :scrollable="true"
            scrollHeight="450px"
            >      
            <template #header>
                <div >               
                <span class="p-input-icon-left w-100">
                    <i class="pi pi-search" />
                    <InputText
                    class="w-100"
                    type="text"
                    v-model="filters['global'].value"
                    placeholder="Buscar..."
                    />
                </span>
                </div>
            </template>   
            <template #empty> No se encontrarón registros. </template>
            <template #loading> Cargando datos. Espere por favor. </template>       
            <Column selectionMode="multiple"></Column>  
            <Column field="Cantidad_agregar" header="Cantidad" sortable style="max-width: 7rem">  
                <template #body="slotProps">
                    <div>
                        <InputNumber :pt="{ input: { style : {width: '100%'}}}" v-model="slotProps.data.Cantidad_agregar" :useGrouping="false"></InputNumber>
                    </div>
                 </template>
            </Column> 
            <Column field="Capitalizable" header="Capitalizable o requiere CBM5" sortable>  
                <template #body="slotProps">
                    <i v-if="slotProps.data.Capitalizable" class="pi pi-check" style="color: green"></i>
                    <i v-else class="pi pi-times" style="color: red"></i>
                 </template>
            </Column> 
            <Column field="Producto" header="PRODUCTO" sortable style="width: 40%">
                <template #body="{data}">
                    {{ data.Producto }} <span v-if="data.PENAEC"><br>PNAEC: {{ data.Numero_penaec }}</span> <span v-if="data.Programa_mantenimiento"><br>Programa mantenimiento: {{ data.Programa_mantenimiento_anio }}</span>
                </template>
            </Column>
            <Column field="Marca" header="MARCA" sortable style="width: 10%"></Column>
            <Column field="Modelo" header="MODELO" sortable style="width: 10%"></Column>
            <Column field="CantidadDisponibles" header="Disponibles" sortable style="width: 10%"></Column>
            <Column
                field="Url_imagen"
                header="IMAGEN"
                :sortable="false"
                style="width: 40%"
            >
                <template #body="slotProps">
                <Image :src="concatenarImagen(slotProps.data.Url_imagen)" alt="Image" :width="slotProps.data.Url_imagen==''?'50':'100'" />
                </template>
            </Column>              
            </DataTable>
            <template #footer>
                <Button label="Agregar seleccionados" icon="pi pi-check" @click="agregarProductosSeleccionados" />
            </template>
        </Dialog>

        <!-- DIALOG DETALLES CBM2-->
        <Dialog 
        :style="{ width: '750px' }"
        :visible="showDialogDetalles"
        :modal="true"   
        :closable="false">
            <template #header>
                <div class="grid w-full">
                    <div class="col-6">
                        <h3>Detalles de la CBM 2</h3>
                    </div>
                    <div class="col-6 flex justify-content-end">
                        <label class="font-bold pr-1">Folio interno: </label>                    
                        <p class="text-500">No. {{ objDetalle.Id_cbm2 }}</p>                        
                    </div>
                </div>
                
            </template>        
            <div class="grid">
                <div class="col-6">
                    <label class="font-bold">Adscripción</label>                    
                    <p class="text-500">{{ objDetalle.Adscrito }}</p>                    
                </div>   
                <div class="col-2">
                    <label class="font-bold">UI</label>                    
                    <p class="text-500">{{ objDetalle.UI?objDetalle.UI:'N/A' }}</p>                    
                </div>                
                <div class="col-2">
                    <label class="font-bold">CC</label>                    
                    <p class="text-500">{{ objDetalle.CC?objDetalle.CC:'N/A' }}</p>                    
                </div>
                <div class="col-2">
                    <label class="font-bold">Fecha</label>                    
                    <p class="text-500">{{ objDetalle.Fecha_registro?getFechaWCF(objDetalle.Fecha_registro,false):'N/A' }}</p>                    
                </div>

                <div class="col-6">
                    <label class="font-bold">El(La) ciudadano(a)</label>
                    <p class="text-500">{{ objDetalle.EL_C?objDetalle.EL_C:'N/A' }}</p>
                </div>
                <div class="col-2">
                    <label class="font-bold">Trabajador de</label>
                    <p class="text-500">{{ objDetalle.Trabajador_de?objDetalle.Trabajador_de:'N/A' }}</p>
                </div>
                <div class="col-2">
                    <label class="font-bold">Matrícula</label>
                    <p class="text-500">{{ objDetalle.Matricula?objDetalle.Matricula:'N/A' }}</p>
                </div>
                <div class="col-2">
                    <label class="font-bold">Identificación</label>
                    <p class="text-500">{{ objDetalle.Identificacion?objDetalle.Identificacion:'N/A' }}</p>
                </div>                

                <div class="col-6">
                    <label class="font-bold">Folio Remedy</label>
                    <p class="text-500">{{ objDetalle.Folio_remedy?objDetalle.Folio_remedy:'N/A' }}</p>
                </div>
                <div class="col-6">
                    <label class="font-bold">Sello</label>
                    <p class="text-500">{{ objDetalle.Sello?objDetalle.Sello:'N/A' }}</p>
                </div>
                
                <div class="col-6">
                    <label class="font-bold">Entrega</label>
                    <p class="text-500">{{ objDetalle.Firma_entrega?objDetalle.Firma_entrega:'N/A' }}</p>
                </div>
                <div class="col-6">
                    <label class="font-bold">Recibe</label>
                    <p class="text-500">{{ objDetalle.Firma_recibe?objDetalle.Firma_recibe:'N/A' }}</p>
                </div>

                <div class="col-6">
                    <label class="font-bold">Sujeto a devolución</label>
                    <p class="text-500">{{ objDetalle.Sujeto_a_devolucion?'SI':'NO' }}</p>
                </div>
                <div class="col-6">
                    <label class="font-bold">Fecha devolución</label>
                    <p class="text-500">{{ objDetalle.Dia_devolucion?objDetalle.Dia_devolucion:'N/A' }}</p>
                </div>

                <div class="col-6">
                    <label class="font-bold">PNAEC</label>
                    <p class="text-500">{{ objDetalle.PENAEC?'SI':'NO' }}</p>
                </div>
                <div v-if="objDetalle.PENAEC" class="col-6">
                    <label class="font-bold">Numero de PNAEC</label>
                    <p class="text-500">{{ objDetalle.Numero_penaec ?? 'N/A' }}</p>
                </div>


                <div class="col-6">
                    <label class="font-bold">Programa de mantenimiento</label>
                    <p class="text-500">{{ objDetalle.Programa_mantenimiento?'SI':'NO' }}</p>
                </div>
                <div v-if="objDetalle.Programa_mantenimiento" class="col-6">
                    <label class="font-bold">Año del programa</label>
                    <p class="text-500">{{ objDetalle.Programa_mantenimiento_anio ?? 'N/A' }}</p>
                </div>


                <div class="col-6">
                    <label class="font-bold">Para su</label>
                    <p class="text-500">{{ objDetalle.Para_su?objDetalle.Para_su:'N/A' }}</p>
                </div>
                <div class="col-6">
                    <label class="font-bold">Estado físico</label>
                    <p class="text-500">{{ objDetalle.Estado_fisico?objDetalle.Estado_fisico:'N/A' }}</p>
                </div>



                <Divider></Divider>
                <div class="col-12">
                    <label class="font-bold">Bienes entregados</label>
                    <DataTable                        
                        :value="objDetalle.Bienes"                              
                        responsiveLayout="scroll"
                        scrollable 
                        scrollDirection="both"
                        scrollHeight="350px"
                        dataKey="Id_cbm2_detalle"   
                        v-model:selection="lstProductosCancelacion"      
                        @row-select="onRowSelect" 
                        :rowClass="isRowSelectable"
                    >                        
                        <template #empty> No se encontrarón registros. </template>
                        <template #loading> Cargando datos. Espere por favor. </template> 
                        <Column :hidden="ocultarCancelacion" selectionMode="multiple" headerStyle="width: 3rem"></Column>                              
                        <Column style="width: 20%" field="Identificacion_cantidad" header="Identificación">
                            <template #editor="{ data, field }">
                                <InputText v-model="data[field]" />
                            </template>
                        </Column>
                        <Column style="width: 20%" field="Naturaleza_bien" header="Naturaleza">
                            <template #editor="{ data, field }">
                                <Dropdown v-model="data[field]" :options="naturalezas" placeholder="Naturaleza del bien">                                    
                                </Dropdown>
                            </template>
                            <template #body="slotProps">
                                <Tag :value="slotProps.data.Naturaleza_bien" severity="success" />
                            </template>
                        </Column>
                        <Column style="width: 60%" field="Descripcion" header="Producto"></Column> 
                        <Column header="Id_estatus">
                            <template #body="slotProps">
                                <Tag :value="util.getEstatusSalidasEquipos(slotProps.data.Id_estatus)?.label" :severity="util.getEstatusSalidasEquipos(slotProps.data.Id_estatus)?.severity" />
                            </template>
                        </Column>                           
                        <Column style="width: 60%"  header="Cancelacion" :class="{'hidden': lstProductosCancelacion.length == 0}">
                            <template #body="slotProps">
                                <InputNumber v-model="slotProps.data.Cantidad_cancelacion" />
                            </template>
                        </Column>                            
                    </DataTable>
                    <div class="w-full flex justify-content-end">
                        <Button :class="{'hidden': lstProductosCancelacion.length == 0}" label="Cancelar seleccionados" icon="pi pi-trash" class="p-button-danger mt-2" @click="cancelarSeleccionados()"/>                                
                    </div>

                </div>               

            </div>
            <template #footer>                
                <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="showDialogDetalles = false"/>                                
                <Button label="Imprimir CBM 2" icon="pi pi-print" class="p-button-text" @click="abrirPDF(objDetalle.Id_cbm2)"/>                                
            </template>
        </Dialog>

        <ConfirmDialog></ConfirmDialog>
    </div>
</template>

<script>
import Utilerias from '../utilidades/Utilerias'
import SrvrInventario from "../service/Inventario";
import SvrProductos from "../service/Productos";
import SvrCbm2 from "../service/CBM2";
import {FilterMatchMode} from 'primevue/api';
import {mapGetters} from 'vuex';
//import axios from "axios";

export default {   
    data(){
        return{
            util: new Utilerias(),
            filtros:{
                unidad: null,
                folio: '',
                fechas: null,
            },
            objSalida: {},
            lstProductos:[],
            lstCBMs2: null,
            loading: true,
            lstUnidades: [],
            lstRCABSUnidad: [],
            lstUnidadesDialog: [],
            selectedUnidadFiltro: null,
            filters: {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS},
                Id_cbm2: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            },
            showNewSalida:false,
            showDialogProductos:false,
            loadingProductos:false,
            selectedProducts: null,
            editingProducts:[],
            naturalezas: [
                 'BMNC',
                 'BC',
                 'BMC',
            ],
            mensajes:null,
            showDialogDetalles: false,
            objDetalle:{},
            submitted: false,
            lstProductosCancelacion : [],
            ocultarCancelacion: false,
        }        
    },
    mounted() {
        var t = this;
        t.cargaInicial();
    },
    methods: {
        isRowSelectable(rowData) {
        // Oculta checkbox si hideCheckboxes es true
        // O puedes añadir otra lógica basada en rowData
            return rowData.Id_estatus == 10 ? 'show-checkbox' : 'hide-checkbox';
        },
        onRowSelect(row){
            let util = new Utilerias();
            row.data.Cantidad_cancelacion = util.esNumero(row.data.Identificacion_cantidad)?? null;
        },
        eliminarProductos(uuid){
            this.objSalida.Productos =  this.objSalida.Productos.filter(e=>e.uuid != uuid);
            this.verificarEquipos();
        },
        onRowEditSave(event){
            let { newData, index } = event;
            this.objSalida.Productos[index] = newData;
        },
        agregarProductosSeleccionados(){
            var t = this;
            
            if(!t.objSalida.Productos)
                t.objSalida.Productos = [];
            
            if(t.selectedProducts){
                t.selectedProducts.forEach(element => {
                    if(element.Cantidad_agregar){
                        for (let index = 0; index < element.Cantidad_agregar; index++) {
                            t.objSalida.Productos.push({
                                uuid: index + element.Id_producto,
                                Identificacion_cantidad: element.Salida_individual?'':'1',
                                Naturaleza_bien: 'BMNC',
                                Descripcion: element.Producto + ' ' + element.Marca + ' ' + element.Modelo + (element.PENAEC ? `, PNAEC ${element.Numero_penaec}` : '') + (element.Programa_mantenimiento ? `, Programa de mantenimiento ${element.Programa_mantenimiento_anio}` : ''),
                                Id_producto: element.Id_producto,
                                PENAEC: element.PENAEC,
                                Numero_penaec: element.Numero_penaec,
                                Programa_mantenimiento: element.Programa_mantenimiento,
                                Programa_mantenimiento_anio: element.Programa_mantenimiento_anio,
                            });
                        }
                    }else{

                        t.objSalida.Productos.push({
                            uuid: new Date().getTime() + element.Id_producto,
                            Identificacion_cantidad: element.Salida_individual?'':'1',
                            Naturaleza_bien: 'BMNC',
                            Descripcion: element.Producto + ' ' + element.Marca + ' ' + element.Modelo + (element.PENAEC ? `, PNAEC ${element.Numero_penaec}` : '') + (element.Programa_mantenimiento ? `, Programa de mantenimiento ${element.Programa_mantenimiento_anio}` : ''),
                            Id_producto: element.Id_producto,
                            PENAEC: element.PENAEC,
                            Numero_penaec: element.Numero_penaec,
                            Programa_mantenimiento: element.Programa_mantenimiento,
                            Programa_mantenimiento_anio: element.Programa_mantenimiento_anio,
                        });
                    }
                });
            }

            t.verificarEquipos();
            
            t.showDialogProductos = false;
        },
        concatenarImagen(urlImagen){
            if(urlImagen != "")
                return this.getUrlServicios + urlImagen.replace("~/","");
            else
                return "../assets/sinImagen.png";
        },
        showGridProductos(){
            var t = this;
            var ctlProductos = new SvrProductos();
            t.loadingProductos = true;
            t.selectedProducts = [];
            ctlProductos.getInsumos(t).then( (res) => {
                t.lstProductos = res.filter((item) => item.Activo);
                t.loadingProductos = false;
            });
            t.showDialogProductos = true;
        },
        cargaRCABSDeUnidad(){
            var t = this;
            
            if(t.objSalida.Unidad_seleccionada){
                this.objSalida.RCAB_seleccionado = null;
                this.lstRCABSUnidad = [];

                var ctlSvr = new SrvrInventario();
                ctlSvr.GetRCABsPorUI(t,t.objSalida.Unidad_seleccionada.Unidad_informacion).then((res) => {                
                    t.lstRCABSUnidad = res;
                });       
            }
        },
        guardarSalida(){
            var t = this;
            var continua = true;
            this.submitted = true;
            t.mensajes = null;

            if((t.objSalida.PENAEC && !t.objSalida.Numero_penaec) || (t.objSalida.Programa_mantenimiento && !t.objSalida.Programa_mantenimiento_anio)){
                return;
            }
            //---------- VALIDACIONES --------------
            if(!t.objSalida || !t.objSalida.RCAB_seleccionado){
                t.mensajes = "Debes seleccionar una unidad y centro de costo con RCAB";
                return;
            }
            if(!t.objSalida || !t.objSalida.Productos || t.objSalida.Productos.length <= 0)
            {
                t.mensajes = "Debes seleccionar cuando menos un producto";
                return;
            }

            t.objSalida.Productos.forEach((prod) => {
                if(!prod.Identificacion_cantidad || prod.Identificacion_cantidad == ''){
                    t.mensajes = "Debe especificar la cantidad o identificador de todos los productos";
                    continua = false;
                    return;
                }
            });
            //---------- VALIDACIONES --------------
            
            if(continua){
                if(!t.objSalida.Sujeto_a_devolucion)
                    t.objSalida.Sujeto_a_devolucion = false;
                else{
                    if(!t.objSalida.Fecha_devolucion)
                    {
                        t.mensajes="Especifique la fecha de devolución";
                        return;
                    }
                }
                
                t.objSalida.Productos.forEach((prod)=>{
                    prod.Estado_fisico = '';
                });

                var cbm2 = {
                    Adscrito: t.objSalida.RCAB_seleccionado.Descripcion_unidad_informacion,
                    Bienes_de: "COORDINACIÓN DE INFORMÁTICA",
                    CC: t.objSalida.RCAB_seleccionado.CC,                    
                    EL_C: t.objSalida.RCAB_seleccionado.Nombre_rcab,                    
                    Firma_entrega: 'ING. CESAR AUGUSTO OCAMPO ROMAN',
                    Firma_recibe: t.objSalida.RCAB_seleccionado.Nombre_rcab,                                        
                    Identificacion: "IMSS",                    
                    Matricula: t.objSalida.RCAB_seleccionado.Matricula_rcab,
                    Para_su: t.objSalida.Para_su?t.objSalida.Para_su:"",                    
                    Sujeto_a_devolucion: t.objSalida.Sujeto_a_devolucion,                    
                    Trabajador_de: "IMSS",
                    Estado_fisico: t.objSalida.Estado_fisico?t.objSalida.Estado_fisico:"",
                    Telefono:'',
                    Dia_devolucion:t.objSalida.Fecha_devolucion?t.objSalida.Fecha_devolucion:"",
                    Folio_remedy:t.objSalida.Folio_remedy?t.objSalida.Folio_remedy:"",
                    Lugar_fecha:'',
                    UBI: t.objSalida.RCAB_seleccionado.Ubicacion,
                    UI: t.objSalida.RCAB_seleccionado.UI,
                    Usuario_registro: t.getUsuarioLogueado.Usuario.Id_usuario,                    
                    Bienes: t.objSalida.Productos,
                    PENAEC: t.objSalida.PENAEC ?? false,
                    Numero_penaec: t.objSalida.PENAEC && t.objSalida.Numero_penaec? t.objSalida.Numero_penaec : "",
                    Programa_mantenimiento: t.objSalida.Programa_mantenimiento?? false,
                    Programa_mantenimiento_anio: t.objSalida.Programa_mantenimiento ? t.objSalida.Programa_mantenimiento_anio instanceof Date && !isNaN(t.objSalida.Programa_mantenimiento_anio) ? t.objSalida.Programa_mantenimiento_anio?.getFullYear()?? "" : t.objSalida.Programa_mantenimiento_anio : null,
                };

                var srvCbm = new SvrCbm2();

                srvCbm.addCbm2(t,cbm2).then((res)=>{                    
                    if(res){
                        t.$toast.add({
                            severity:"success",
                            summary:"AVISO",
                            detail:"Salida generada correctamente",
                            life: 4000
                        });
                        t.abrirPDF(res.Id_cbm2);
                        t.cerrarDialogo();
                    }
                });
               
            }

        },
        abrirPDF(id){
            
            window.open(this.getUrlReportes + "CBM_02&rs:Format=PDF&ID_CBM=" + id, '_blank');
            // axios.get(this.getUrlReportes + "CBM_02&rs:Format=PDF&ID_CBM=" + id).then((res)=>{
            //     console.log(res);
            // }).catch((err)=>{
            //     console.log(err);
            // });
        },
        cerrarDialogo(){
            this.objSalida = {};
            this.objSalida.RCAB_seleccionado = null;
            this.lstRCABSUnidad = [];
            this.showNewSalida = false;
            this.mensajes = null;     
            this.submitted = false;       
        },
        verDetallesCBM2(obj){
            var t = this;
            var svrCBM =  new SvrCbm2();

            t.showDialogDetalles = true;
            t.objDetalle = {...obj};

            svrCBM.GetBienesCbm2(t,t.objDetalle.Id_cbm2).then((res)=>{
                t.lstProductosCancelacion = [];
                t.objDetalle.Bienes = res;
                t.ocultarCancelacion = !t.objDetalle.Bienes.some(b => b.Id_estatus == 10);
            });

            //console.log(obj);
        },
        agregarSalida(){                               
            if(this.selectedUnidadFiltro?.Unidad_informacion){
                this.objSalida.Unidad_seleccionada = this.selectedUnidadFiltro;
                this.cargaRCABSDeUnidad();
            }
            this.showNewSalida = true;
            this.objSalida.Sujeto_a_devolucion=false;
        },
        cargaInicial() {
            var t = this;

            var ctlSvr = new SrvrInventario();
            
            ctlSvr.GetUnidadesFromIMAM(t).then((res) => {
                
                t.lstUnidades = [...res.Unidades];
                t.lstUnidadesDialog = [...res.Unidades];
                t.lstUnidades.unshift({
                    Unidad_informacion: 0,
                    Descripcion_unidad_informacion: "TODOS",
                });
            });   
        },
        getDistinctUnidad(lista){
            let newLista = [];
            lista.forEach(element => {
                let existe = newLista.find(e=> e.UNIDAD == element.UNIDAD);
                if(!existe){
                    newLista.push({
                        UNIDAD: element.UNIDAD,                        
                    });
                }
            });

            return newLista;
        },
        getFechaWCF(fecha,hora){
            var utils = new Utilerias();
            return utils.getFechaWCF(fecha,hora);
        },
        verificarEquipos(){
            let t = this;
            let equipo_penaec = t.objSalida.Productos.find(p => p.PENAEC);
            t.objSalida.PENAEC = equipo_penaec ? equipo_penaec.PENAEC : false;
            t.objSalida.Numero_penaec = equipo_penaec ? equipo_penaec.Numero_penaec : null;
            

            let equipo_mantenimiento = t.objSalida.Productos.find(p => p.PENAEC);
            t.objSalida.Programa_mantenimiento = equipo_mantenimiento ? equipo_mantenimiento.Programa_mantenimiento : false;
            t.objSalida.Programa_mantenimiento_anio = equipo_mantenimiento ? equipo_mantenimiento.Programa_mantenimiento_anio : null;
        },
        //FUNCION PARA EL FILTRO POR MEDIO DEL BOTON
        btnFiltro(){
            const btnFiltro = document.getElementById('id-btn-filtro');
            var t = this;
            var srvCBM = new SvrCbm2();
        
            t.loading = true;
            btnFiltro.disabled = true; // Corregido "disabiled" por "disabled"
        
            if(!t.filtros.unidad){
                t.$toast.add({
                    severity:"warn", 
                    summary:"AVISO",
                    detail:"El campo unidad no puede ir vacío",
                    life: 4000
                });
                t.loading = false;
                btnFiltro.disabled = false;
                return;
            }

            if(t.filtros.folio !== '' && isNaN(t.filtros.folio)){
                t.$toast.add({
                    severity:"warn", 
                    summary:"AVISO",
                    detail:"El campo folio debe ser un número",
                    life: 4000
                });
                t.loading = false;
                btnFiltro.disabled = false;
                return;
            }
            
            if(t.filtros.folio !== '' && Number(t.filtros.folio) <= 0){
                t.$toast.add({
                    severity:"warn", 
                    summary:"AVISO", 
                    detail:"El campo folio tiene que ser mayor a 0",
                    life: 4000
                });
                t.loading = false;
                btnFiltro.disabled = false;
                return;
            }

            if(t.filtros.unidad.Unidad_informacion == 0){
                // Cuando se selecciona "Todos"
                if(t.filtros.folio == "" && !t.filtros.fechas){
                    srvCBM.getAllCBM2(t).then((res)=>{                               
                        t.lstCBMs2 = res;
                        t.loading = false;
                        btnFiltro.disabled = false;
                    }).catch(error => {
                        t.loading = false;
                        btnFiltro.disabled = false;
                        t.$toast.add({
                            severity:"error",
                            summary:"ERROR",
                            detail:"Error al obtener los datos" + error,
                            life: 4000
                        });
                    });
                } else {
                    srvCBM.getAllCBM2Filtro(t, t.filtros).then((res)=>{                               
                        t.lstCBMs2 = res;
                        t.loading = false;
                        btnFiltro.disabled = false;
                    }).catch(error => {
                        t.loading = false;
                        btnFiltro.disabled = false;
                        t.$toast.add({
                            severity:"error", 
                            summary:"ERROR",
                            detail:"Error al obtener los datos filtrados" + error,
                            life: 4000
                        });
                    });
                }
            } else {
                // Cuando se selecciona una unidad específica
                srvCBM.GetCbm2PorUI(t, t.filtros).then((res)=>{                    
                    t.lstCBMs2 = res;
                    t.loading = false;
                    btnFiltro.disabled = false;
                }).catch(error => {
                    t.loading = false;
                    btnFiltro.disabled = false;
                    t.$toast.add({
                        severity:"error",
                        summary:"ERROR", 
                        detail:"Error al obtener los datos de la unidad" + error,
                        life: 4000
                    });
                });
            }
        },
        btnLimpiarFiltro(){
            this.filtros = {
                unidad: null,
                folio: '',
                fechas: null,
            };
            this.lstCBMs2 = null;
            this.selectedUnidadFiltro = null;
        },
        cancelarSeleccionados(){
            let t = this;
            if(t.lstProductosCancelacion.some(item => !item.Cantidad_cancelacion)){
                t.$toast.add({
                    severity:"success",
                    summary:"AVISO",
                    detail:"Debe especificar una cantidad para cancelar",
                    life: 4000
                });
                return;
            }

            t.$confirm.require({
                message: '¿Esta seguro que desea cancelar los registros?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sí, eliminar',
                rejectLabel: 'Cancelar',
                acceptClass: 'p-button-danger',
                accept: () => {
                    let cbm = {...t.objDetalle}
                    cbm.Bienes = t.lstProductosCancelacion;
                    cbm.Id_usuario_cancela = t.getUsuarioLogueado.Usuario.Id_usuario;
                    var svrCBM =  new SvrCbm2();
                    svrCBM.Delete(t,cbm).then(res => {
                        t.verDetallesCBM2(res);
                        t.$toast.add({
                            severity:"success",
                            summary:"AVISO",
                            detail:"Cambios guardados correctamente",
                            life: 5000
                        });
                        t.lstProductosCancelacion = [];
                        
                    });
                },
                reject: () => {
                    // Usuario canceló
                }
            });
        }
    },
    computed:{
        ...mapGetters(['getUrlServicios','getUsuarioLogueado','getUrlReportes']),  
    },  
}
</script>

<style>
    .hide-checkbox .p-checkbox {
        display: none !important;
    }
</style>

<style lang="scss" scoped>
::v-deep(.editable-cells-table td.p-cell-editing) {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
}
</style>